import React, { useState } from "react";

function AddStockModal({ onClose, onAdd }) {
  const [symbol, setSymbol] = useState("");
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [qty, setQty] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!symbol.trim()) return;

    setLoading(true);
    setStatus(null);
    try {
      await onAdd({
        symbol: symbol.trim(),
        name: name.trim() || null,
        purchase_price: price === "" ? null : price,
        quantity: qty === "" ? null : qty,
      });
      onClose();
    } catch (err) {
      setStatus({ type: "error", message: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <div className="modal-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </div>
        <h2>הוספת מניה</h2>
        <p className="modal-desc">הסימול הוא שדה חובה. מחיר וכמות אופציונליים וניתן לעדכן אותם בכל שלב.</p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="סימול — לדוגמה AAPL"
            value={symbol}
            onChange={(e) => setSymbol(e.target.value.toUpperCase())}
            className="modal-input"
            dir="ltr"
            autoFocus
          />
          <input
            type="text"
            placeholder="שם החברה (אופציונלי)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="modal-input field-input"
          />
          <div className="modal-row">
            <input
              type="number"
              step="any"
              min="0"
              placeholder="מחיר רכישה"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="modal-input field-input"
              dir="ltr"
            />
            <input
              type="number"
              step="any"
              min="0"
              placeholder="כמות"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
              className="modal-input field-input"
              dir="ltr"
            />
          </div>
          <button type="submit" className="modal-submit" disabled={loading || !symbol.trim()}>
            {loading ? "מוסיף..." : "הוסף לרשימה"}
          </button>
        </form>

        {status && <div className={`modal-status ${status.type}`}>{status.message}</div>}
      </div>
    </div>
  );
}

export default AddStockModal;
